<script setup>
import BreezeButton from '@/Components/Button.vue';
import Layout from '@/Layouts/Layout.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, useForm } from '@inertiajs/inertia-vue3';
import { __ } from '@/app';
import LayoutNew from '@/Layouts/LayoutNew.vue';
import FormHeader from '@/Components/FormHeader.vue';

const props = defineProps({
    email: String,
    token: String,
});

const form = useForm({
    token: props.token,
    email: props.email,
    password: '',
    password_confirmation: '',
});

const submit = () => {
    form.post(route('password.update'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>

<template>
    <LayoutNew>
        <Head v-bind:title="__('Zresetuj hasło')" />        
        <div style="max-width: 450px; width: 100%;">
            <FormHeader v-bind:title="__('Zresetuj hasło')"/>

            <div>
                <BreezeValidationErrors class="mb-4 alert alert-danger" />
                
                <form @submit.prevent="submit">
                    <div class="mb-2">
                        <label for="email" class="form-label" v-text="__( 'Adres Email' )"/>
                        <BreezeInput v-bind:placeholder="__('Enter your email')" id="email" type="email" class="form-control" v-model="form.email" required autofocus autocomplete="username" />
                        <div class="error" id="emailError"></div>
                    </div>
                    <div class="mb-2">
                        <label for="password" class="form-label" v-text="__('Hasło')"/>
                        <BreezeInput v-bind:placeholder="__('Wprowadź swoje hasło')" id="password" type="password" class="block w-full" v-model="form.password" required autocomplete="current-password" />
                        <div class="error" id="passwordError"></div>
                    </div>
                    <div class="mb-2">
                        <label for="password_confirmation" class="form-label" v-text="__('Potwierdź hasło')"/>
                        <BreezeInput v-bind:placeholder="__('Potwierdź hasło')" id="password_confirmation" type="password" class="block w-full" v-model="form.password_confirmation" required autocomplete="current-password" />
                        <div class="error" id="passwordError"></div>
                    </div>
                    
                    <button type="submit" class="btn btn-primary w-100 p-3" v-text="__( 'Zresetuj hasło' )"/>                
                </form>
            </div>
        </div>         
    </LayoutNew>
</template>